<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div class="text-xs-center">
		<v-dialog
            persistent
			v-model="dialog"
			width="500">
			<v-card>
				<v-card-title
					class="headline"
					primary-title
				>
					Porównywanie wersji
				</v-card-title>

				<v-alert :value="correctionsNotApplied" type="warning" class="ma-3">
					Oferta ma tylko jedną wysłaną wersję.
				</v-alert>

				<v-card-text>
					<v-select label="Późniejsza wersja" v-model="selected.secondSelected"
						:items="selections.secondItems" aria-label="later version">

					</v-select>
					<v-select label="Wcześniejsza wersja" v-model="selected.firstSelected"
						:items="selections.firstItems"
						aria-label="earlier version">

					</v-select>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						:disabled="correctionsNotApplied"
						color="blue"
						@click="compareLastTwoVersions()"
					>
						Porównaj ostatnie dwie
					</v-btn>
					<v-btn
						:disabled="!selectionEnabled"
						color="primary"
						@click="compareTwoChosenVersions(selected.firstSelected, selected.secondSelected)"
					>
						Porównaj
					</v-btn>
					<v-btn
						color="secondary"
						flat
						@click="closeDialog">
						Zamknij
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
	export default {
		name: "CompareFinalReportDialog",

		data() {
			return {
				selected: {
					firstSelected: null,
					secondSelected: null,
				},
                projectId: this.$route.params.projectId

			};
		},

		props: {
            dialog: {type: Boolean, default: true},
			lastVersion: null,
			contestId: null,
		},

		computed: {
            selections(){
                let selections = {firstItems: [], secondItems: []};
                selections.firstItems = Array.from({length: this.selected.secondSelected-1}, (v, k) => k+1  );
				selections.secondItems = Array.from({length: this.lastCompletedVersion +1}, (v, k) => k );
                selections.secondItems.shift();
                return selections;
            },
			selectionEnabled() {
				return (this.selected.firstSelected !== null) && (this.selected.secondSelected !== null) && (this.selected.firstSelected < this.selected.secondSelected);
			},

            lastCompletedVersion() {
        return this.lastVersion;
      },

      correctionsNotApplied() {
        return this.lastCompletedVersion < 2;
      },

		},

		methods: {

			compareLastTwoVersions() {
				this.compareTwoChosenVersions(this.lastCompletedVersion - 1, this.lastCompletedVersion);
			},
			compareTwoChosenVersions(first, second) {
                this.$router.openInNewTab("/view/final-report/" + this.projectId + "/comparison/" + first + "/" + second);
			},


			closeDialog() {
                this.$emit("hideReportDialogComparison");
			},
		},
	};
</script>

<style scoped>

</style>